import convert from "convert-units";
import { coins_units, units_10 } from "../constants.js";
import { convertUnits } from "./convert.js";

//Codigos que se ven en los formularios
export const wasteCodes = {
  paper_and_cardboard: "re1", // Papel y cartón
  plastic: "re2", // Plástico
  fabric_scraps: "re3", // Tela o retazos
  metal_clean: "re4", // Metal (agujas o virutas no contaminadas)
  wood: "re5", // Madera
  food_waste: "re6", // Restos de comida
  general_trash: "re7", // Basura General
  glass: "re8", // Vidrio
  leather: "re9", // Cuero
  foam_eva: "re10", // Espuma (eva)
  empty_cans_or_containers: "re11", // Latas o recipientes vacios (no peligrosos)
  rubber: "re12", // Caucho (rubber)
  other_non_hazardous_waste: "re13",
  // Otros residuos no peligrosos

  electronic_waste: "Re14", // Residuos electrónicos
  empty_chemical_containers: "Re15", // Envases vacíos Químicos (peligrosos)
  cleaning_pesticide_containers: "Re16", // Envases de limpieza y pesticidas (peligrosos)
  batteries: "Re17", // Baterías
  fluorescent_tubes: "Re18", // Tubos fluorescentes
  cooking_oil: "Re19", // Aceite de cocina
  maintenance_oil: "Re20", // Aceite de mantenimiento
  lubricants: "Re21", // Lubricantes
  paint_waste: "Re22", // Restos de pinturas
  coal_ashes: "Re23", // Cenizas de carbón
  rubber_hazardous: "Re24", // Caucho (rubber) (peligroso)
  chemicals: "Re25", // Químicos
  contaminated_materials: "Re26", // Materiales contaminados
  ink_cartridges: "Re27", // Cartuchos de tinta
  medical_waste: "Re28", // Residuos médicos (patogénicos)
  other_hazardous_waste: "Re29", // Otros residuos peligrosos
};

//Codigos de los indicadores que se ven en el dashboard
export const wasteKPIsCodes = {
  // Residuos no peligrosos
  paper_and_cardboard_kpis: "KPIrnp1", // Papel y cartón / unidad
  plastic_kpis: "KPIrnp2", // Plástico / unidad
  fabric_or_scraps_kpis: "KPIrnp3", // Tela o scrap, retazos / unidad
  metal_kpis: "KPIrnp4", // Metal (agujas o virutas no contaminadas) / unidad
  wood_kpis: "KPIrnp5", // Madera / unidad
  leftover_food_kpis: "KPIrnp6", // Restos de comida / empleados
  general_trash_kpis: "KPIrnp7", // Basura General / empleados
  glass_kpis: "KPIrnp8", // Vidrio / unidad
  leather_kpis: "KPIrnp9", // Cuero / unidad
  foam_kpis: "KPIrnp10", // Espuma (eva) / unidad
  empty_cans_or_containers_not_dangerous_kpis: "KPIrnp11", // Latas o recipientes vacíos (no peligrosos) / unidad
  rubber_kpis: "KPIrnp12", // Caucho (rubber) / unidad
  other_non_hazardous_kpis: "KPIrnp13", // Otros no peligrosos / unidad
  total_non_hazardous_waste_kpis: "KPIrnp14", // Total Residuos no Peligrosos
  total_non_hazardous_waste_unit_kpis: "KPIrnp15", // Total residuos no peligrosos / unidad

  // Residuos peligrosos
  electronic_waste_kpis: "KPIrep1", // Residuos electrónicos / unidad
  empty_chemical_containers_kpis: "KPIrep2", // Envases vacíos Químicos (peligrosos) / unidad
  cleaning_pesticide_containers_kpis: "KPIrep3", // Envases de limpieza y pesticidas (peligrosos) / unidad
  batteries_kpis: "KPIrep4", // Baterías / unidad
  fluorescent_tubes_kpis: "KPIrep5", // Tubos fluorescentes / unidad
  cooking_oil_kpis: "KPIrep6", // Aceite de cocina / unidad
  maintenance_oil_kpis: "KPIrep7", // Aceite de mantenimiento / unidad
  lubricants_kpis: "KPIrep8", // Lubricantes / unidad
  paint_remains_kpis: "KPIrep9", // Restos de pinturas / unidad
  coal_ashes_kpis: "KPIrep10", // Cenizas de carbón / unidad
  rubber_hazardous_kpis: "KPIrep11", // Caucho (rubber) / unidad
  chemicals_kpis: "KPIrep12", // Químicos / unidad
  contaminated_materials_kpis: "KPIrep13", // Materiales contaminados / unidad
  ink_cartridges_kpis: "KPIrep14", // Cartuchos de tinta / unidad
  medical_waste_kpis: "KPIrep15", // Residuos médicos (patogénicos) / unidad
  other_hazardous_waste_kpis: "KPIrep16", // Otros residuos peligrosos / unidad
  total_hazardous_waste_kpis: "KPIrep17", // Total de residuos peligrosos
  total_hazardous_waste_unit_kpis: "KPIrep18", // Total residuos peligrosos / unidad
};

export const disposalMethodCode = {
  // Residuos no peligrosos
  reuse_recycling_rnp: "KPIrnp16", // Reutilizados y reciclados
  composting_rnp: "KPIrnp17", // Compostaje
  energy_recovery_rnp: "KPIrnp18", // Recuperación de energía
  incineration_no_energy_recovery_rnp: "KPIrnp19", // Incinerados sin recuperación de energía
  landfill_rnp: "KPIrnp20", // Vertederos / Relleno sanitario
  other_methods_rnp: "KPIrnp21", // Otros métodos de disposición

  // Residuos peligrosos
  reuse_recycling_rep: "KPIrep19", // Reutilizados y reciclados
  energy_recovery_rep: "KPIrep20", // Recuperación de energía
  incineration_no_energy_recovery_rep: "KPIrep21", // Incinerados sin recuperación de energía
  landfill_rep: "KPIrep22", // Vertederos / Relleno sanitario
  other_methods_rep: "KPIrep23", // Otros métodos de disposición
};

export const disposalMethods = [
  "reuse",
  "recycling",
  "composting",
  "energy_recovery",
  "incineration_non_recyclable_waste_energy_recovery",
  "landfill_control_measures",
  "incineration_recyclable_waste_energy_recovery",
  "incineration_without_energy_recovery",
  "non_controlled_sanitary_filling",
  "others",
];

//En base al valor del campo / key devuelve el valor correspondiente de acuerdo al año es de tipo {total, unit}
export function wasteFormulasIndicators(field, year, data, baseline, cantW) {
  switch (field) {
    case "paper_and_cardboard_kpis":
      return {
        total: data["paper_and_cardboard"]?.[year].total / baseline,
        unit: data["paper_and_cardboard"]?.[year].unit,
      };
    case "plastic_kpis":
      return {
        total: data["plastic"]?.[year].total / baseline,
        unit: data["plastic"]?.[year].unit,
      };
    case "fabric_or_scraps_kpis":
      return {
        total: data["fabric_scraps"]?.[year].total / baseline,
        unit: data["fabric_scraps"]?.[year].unit,
      };
    case "metal_kpis":
      return {
        total: data["metal_clean"]?.[year]?.total / baseline,
        unit: data["metal_clean"]?.[year]?.unit,
      };
    case "wood_kpis":
      return {
        total: data["wood"]?.[year]?.total / baseline,
        unit: data["wood"]?.[year]?.unit,
      };
    case "leftover_food_kpis":
      //cantidad de trabajadores
      return {
        total: data["food_waste"]?.[year]?.total / cantW,
        unit: data["food_waste"]?.[year]?.unit,
      };
    case "general_trash_kpis":
      //cantidad de trabajadores
      return {
        total: data["general_trash"]?.[year]?.total / cantW,
        unit: data["general_trash"]?.[year]?.unit,
      };
    case "glass_kpis":
      return {
        total: data["glass"]?.[year]?.total / baseline,
        unit: data["glass"]?.[year]?.unit,
      };
    case "leather_kpis":
      return {
        total: data["leather"]?.[year]?.total / baseline,
        unit: data["leather"]?.[year]?.unit,
      };
    case "foam_kpis":
      return {
        total: data["foam_eva"]?.[year]?.total / baseline,
        unit: data["foam_eva"]?.[year]?.unit,
      };
    case "empty_cans_or_containers_not_dangerous_kpis":
      return {
        total: data["empty_cans_or_containers"]?.[year]?.total / baseline,
        unit: data["empty_cans_or_containers"]?.[year]?.unit,
      };
    case "rubber_kpis":
      return {
        total: data["rubber"]?.[year]?.total / baseline,
        unit: data["rubber"]?.[year]?.unit,
      };
    case "other_non_hazardous_kpis":
      return {
        total: data["other_non_hazardous_waste"]?.[year]?.total / baseline,
        unit: data["other_non_hazardous_waste"]?.[year]?.unit,
      };
    case "total_non_hazardous_waste_kpis": {
      const keys = [
        "paper_and_cardboard",
        "plastic",
        "fabric_scraps",
        "metal_clean",
        "wood",
        "food_waste",
        "general_trash",
        "glass",
        "leather",
        "foam_eva",
        "empty_cans_or_containers",
        "rubber",
        "other_non_hazardous_waste",
      ];

      const unit = keys.map((k) => data[k]?.[year]?.unit).find(Boolean);

      return {
        total: addData(keys, year, data, unit),
        unit,
      };
    }

    case "total_non_hazardous_waste_unit_kpis":
      const result = wasteFormulasIndicators(
        "total_non_hazardous_waste_kpis",
        year,
        data,
        baseline,
        cantW
      );
      return {
        total: result.total / baseline,
        unit: result.unit, //TODO
      };

    case "reuse_recycling_rnp": {
      const keys3 = ["reuse", "recycling"];

      const unit = keys3
        .map((k) => data[k]?.[year]?.["rnp"]?.unit)
        .find(Boolean);

      return {
        total: addDataByConcept(keys3, year, data, "rnp"),
        unit,
      };
    }

    case "composting_rnp":
      return {
        total: data["composting"]?.[year]?.["rnp"].total,
        unit: data["composting"]?.[year]?.["rnp"].unit,
      };
    case "energy_recovery_rnp": {
      const keys4 = [
        "energy_recovery",
        "incineration_non_recyclable_waste_energy_recovery",
        "incineration_recyclable_waste_energy_recovery",
      ];

      const unit = keys4
        .map((k) => data[k]?.[year]?.["rnp"]?.unit)
        .find(Boolean);

      return {
        total: addDataByConcept(keys4, year, data, "rnp"),
        unit,
      };
    }

    case "incineration_no_energy_recovery_rnp":
      return {
        total:
          data["incineration_without_energy_recovery"]?.[year]?.["rnp"].total,
        unit: data["incineration_without_energy_recovery"]?.[year]?.["rnp"]
          .unit,
      };
    case "landfill_rnp": {
      const keys5 = [
        "landfill_control_measures",
        "non_controlled_sanitary_filling",
      ];

      const unit = keys5
        .map((k) => data[k]?.[year]?.["rnp"]?.unit)
        .find(Boolean);

      return {
        total: addDataByConcept(keys5, year, data, "rnp"),
        unit,
      };
    }

    case "other_methods_rnp":
      return {
        total: data["others"]?.[year]?.["rnp"].total,
        unit: data["others"]?.[year]?.["rnp"].unit,
      };

    case "electronic_waste_kpis":
      return {
        total: data["electronic_waste"]?.[year].total / baseline,
        unit: data["electronic_waste"]?.[year].unit,
      };
    case "empty_chemical_containers_kpis":
      return {
        total: data["empty_chemical_containers"]?.[year].total / baseline,
        unit: data["empty_chemical_containers"]?.[year].unit,
      };
    case "cleaning_pesticide_containers_kpis":
      return {
        total: data["cleaning_pesticide_containers"]?.[year].total / baseline,
        unit: data["cleaning_pesticide_containers"]?.[year].unit,
      };

    case "batteries_kpis":
      return {
        total: data["batteries"]?.[year].total / baseline,
        unit: data["batteries"]?.[year].unit,
      };
    case "fluorescent_tubes_kpis":
      return {
        total: data["fluorescent_tubes"]?.[year].total / baseline,
        unit: data["fluorescent_tubes"]?.[year].unit,
      };
    case "cooking_oil_kpis":
      return {
        total: data["cooking_oil"]?.[year].total / baseline,
        unit: data["cooking_oil"]?.[year].unit,
      };
    case "maintenance_oil_kpis":
      //cantidad de trabajadores
      return {
        total: data["maintenance_oil"]?.[year].total / baseline, //cambiar a baseline
        unit: data["maintenance_oil"]?.[year].unit,
      };
    case "lubricants_kpis":
      return {
        total: data["lubricants"]?.[year].total / baseline,
        unit: data["lubricants"]?.[year].unit,
      };
    case "paint_remains_kpis":
      return {
        total: data["paint_waste"]?.[year].total / baseline,
        unit: data["paint_waste"]?.[year].unit,
      };
    case "coal_ashes_kpis":
      return {
        total: data["coal_ashes"]?.[year].total / baseline,
        unit: data["coal_ashes"]?.[year].unit,
      };
    case "rubber_hazardous_kpis":
      return {
        total: data["rubber_hazardous"]?.[year].total / baseline,
        unit: data["rubber_hazardous"]?.[year].unit,
      };
    case "chemicals_kpis":
      return {
        total: data["chemicals"]?.[year].total / baseline,
        unit: data["chemicals"]?.[year].unit,
      };
    case "contaminated_materials_kpis":
      return {
        total: data["contaminated_materials"]?.[year].total / baseline,
        unit: data["contaminated_materials"]?.[year].unit,
      };
    case "ink_cartridges_kpis":
      return {
        total: data["ink_cartridges"]?.[year].total / baseline,
        unit: data["ink_cartridges"]?.[year].unit,
      };
    case "medical_waste_kpis":
      return {
        total: data["medical_waste"]?.[year].total / baseline,
        unit: data["medical_waste"]?.[year].unit,
      };
    case "other_hazardous_waste_kpis":
      return {
        total: data["other_hazardous_waste"]?.[year].total / baseline,
        unit: data["other_hazardous_waste"]?.[year].unit,
      };
    case "total_hazardous_waste_kpis": {
      const keys2 = [
        "electronic_waste",
        "empty_chemical_containers",
        "cleaning_pesticide_containers",
        "batteries",
        "fluorescent_tubes",
        "cooking_oil",
        "maintenance_oil",
        "lubricants",
        "paint_waste",
        "coal_ashes",
        "rubber_hazardous",
        "chemicals",
        "contaminated_materials",
        "ink_cartridges",
        "medical_waste",
        "other_hazardous_waste",
      ];

      const unit = keys2.map((k) => data[k]?.[year]?.unit).find(Boolean);

      return {
        total: addData(keys2, year, data, unit),
        unit,
      };
    }

    case "total_hazardous_waste_unit_kpis":
      const result2 = wasteFormulasIndicators(
        "total_hazardous_waste_kpis",
        year,
        data,
        baseline,
        cantW
      );

      return {
        total: result2.total / baseline,
        unit: result2.unit, //TODO RE
      };

    case "reuse_recycling_rep": {
      const keys10 = ["reuse", "recycling"];

      const unit = keys10
        .map((k) => data[k]?.[year]?.["rep"]?.unit)
        .find(Boolean);

      return {
        total: addDataByConcept(keys10, year, data, "rep"),
        unit,
      };
    }

    case "energy_recovery_rep": {
      const keys7 = [
        "energy_recovery",
        "incineration_non_recyclable_waste_energy_recovery",
        "incineration_recyclable_waste_energy_recovery",
      ];

      const unit = keys7
        .map((k) => data[k]?.[year]?.["rep"]?.unit)
        .find(Boolean);

      return {
        total: addDataByConcept(keys7, year, data, "rep"),
        unit,
      };
    }

    case "incineration_no_energy_recovery_rep":
      return {
        total:
          data["incineration_without_energy_recovery"]?.[year]?.["rep"].total,
        unit: data["incineration_without_energy_recovery"]?.[year]?.["rep"]
          .unit,
      };
    case "landfill_rep": {
      const keys8 = [
        "landfill_control_measures",
        "non_controlled_sanitary_filling",
      ];

      const unit = keys8
        .map((k) => data[k]?.[year]?.["rep"]?.unit)
        .find(Boolean);

      return {
        total: addDataByConcept(keys8, year, data, "rep"),
        unit,
      };
    }

    case "other_methods_rep":
      return {
        total: data["others"]?.[year]?.["rep"].total,
        unit: data["others"]?.[year]?.["rep"].unit,
      };

    default:
      return false;
  }
}

//Suma los valores de los campos/claves pasadas como parametros
function addData(keys, year, data, unitSelected) {
  let suma = 0;
  //tomo como referencia el kwh
  for (let clave of keys) {
    if (data.hasOwnProperty(clave)) {
      suma +=
        convertUnits(
          data[clave]?.[year].total,
          data[clave]?.[year].unit,
          unitSelected
        ) || 0;
    }
  }

  return suma;
}

// Esta función suma los totales de cada concepto (rnp o rep) para un año dado
const addDataByConcept = (keys, year, data, concept) => {
  return keys.reduce((sum, key) => {
    // Si el dato existe para el concepto y el año, sumamos el total correspondiente
    if (data[key] && data[key][year] && data[key][year][concept]) {
      return sum + (data[key][year]?.[concept].total || 0); // Asegurarse de que 'total' exista
    }
    return sum;
  }, 0);
};

//Determina las unidades utilizadas de acuerdo a cada campo/key ver boceto con unidades
export const determineWasteUnits = (value) => {
  return units_10.map((unit) => ({ ...unit, text: unit.name }));
};

export function convertWithDensityWaste(
  valor,
  unidadOrigen,
  unidadDestino,
  densidad,
  unidadDensidad
) {
  unidadOrigen = unidadOrigen?.toLowerCase?.() ?? unidadOrigen;
  unidadDestino = unidadDestino?.toLowerCase?.() ?? unidadDestino;
  // Definir las conversiones de masa
  const conversionesMasa = {
    g: 1,
    kg: 1000,
    ton: 1000000,
    t: 1000000,
  };

  // Definir las conversiones de volumen
  const conversionesVolumen = {
    l: 1,
    m3: 1000, // 1 m3 = 1000 litros
  };

  // Convertir densidad a g/cm³
  const convertirDensidadAGramosPorCm3 = (densidad, unidadDensidad) => {
    switch (unidadDensidad) {
      case "kg/m3":
        return densidad / 1000; // Convertir kg/m³ a g/cm³
      case "ton/m3":
        return densidad * 1000; // Convertir ton/m³ a g/cm³
      case "g/cm3":
        return densidad; // Si ya es g/cm³, no hay conversión
      default:
        console.error("Unidad de densidad no soportada");
        return NaN; // Retorna NaN si la unidad de densidad no es válida
    }
  };

  // Verificar si estamos trabajando con masa
  const esMasa = (unidad) => ["g", "kg", "ton", "t"].includes(unidad);
  // Verificar si estamos trabajando con volumen
  const esVolumen = (unidad) => ["l", "m3"].includes(unidad);

  // Convertir la densidad a g/cm³ si no está ya en esa unidad
  const densidadEnGcm3 = convertirDensidadAGramosPorCm3(
    densidad,
    unidadDensidad
  );

  // Si la densidad no es válida, retornar NaN
  if (isNaN(densidadEnGcm3)) {
    console.error("La densidad no es válida.");
    return NaN;
  }

  // Convertir entre masa y volumen (con densidad)
  if (esMasa(unidadOrigen) && esVolumen(unidadDestino)) {
    // Convertir la masa a gramos
    const valorEnGramos = valor * conversionesMasa[unidadOrigen];
    // Convertir a volumen usando densidad (en g/cm³)
    const volumenEnCm3 = valorEnGramos / densidadEnGcm3; // en cm³
    // Convertir cm³ a la unidad de volumen deseada (litros o m³)
    if (unidadDestino === "l") {
      return volumenEnCm3 / 1000; // Convertir a litros (1 litro = 1000 cm³)
    } else if (unidadDestino === "m3") {
      return volumenEnCm3 / 1000000; // Convertir a m³ (1 m³ = 1,000,000 cm³)
    }
  }

  if (esVolumen(unidadOrigen) && esMasa(unidadDestino)) {
    // Convertir el volumen a litros o m³
    const valorEnVolumen = valor * conversionesVolumen[unidadOrigen];
    // Convertir a masa usando densidad (en g/cm³ o kg/m³)
    const masaEnGramos = valorEnVolumen * densidadEnGcm3 * 1000; // convertimos a gramos
    return masaEnGramos / conversionesMasa[unidadDestino];
  }

  // Si las unidades son de masa o volumen y son iguales
  if (esMasa(unidadOrigen) && esMasa(unidadDestino)) {
    const valorEnGramos = valor * conversionesMasa[unidadOrigen];
    return valorEnGramos / conversionesMasa[unidadDestino];
  }

  if (esVolumen(unidadOrigen) && esVolumen(unidadDestino)) {
    const valorEnVolumen = valor * conversionesVolumen[unidadOrigen];
    return valorEnVolumen / conversionesVolumen[unidadDestino];
  }

  return "Conversión no válida";
}

export const densidades = {
  // "water": 1.00,  // 1 g/cm³ (1000 kg/m³)
  // "iron": 7.87,  // 7.87 g/cm³
  // "wood": 0.60,  // 0.60 - 1.00 g/cm³
  // "glass": 2.50,  // 2.50 g/cm³
  // "oil": 0.92,  // 0.92 g/cm³
  // "ethanol": 0.79,  // 0.79 g/cm³
  // "polyethylene": 0.92,  // 0.92 g/cm³
  // "biomassa":1,
  // "gasoline":0.74,
  // "biodiesel":1,
  // "diesel":0.84,
  paper_and_cardboard: {
    density: 0.8,
    unit_density: "g/cm3",
  }, // Promedio de papel y cartón
  // "plastic": 1.00,  // Promedio de plástico (tipo general)
  // "fabric_or_scraps": 0.80,  // Promedio de telas (puede variar mucho)
  // "metal": 8.00,  // Promedio de metales como acero o hierro
  // "food": 0.80,  // Promedio de restos de comida orgánica
  // "leather": 1.20,  // Promedio de cuero
  // "foam": 0.10,  // Promedio de espuma EVA
  // "empty_cans_or_containers_not_dangerous": 2.70,  // Promedio de latas (aluminio o acero)
  // "otros_residuos": 1.00  // Promedio de otros residuos no peligrosos
};

export const convertUnitsFinal = (value, unita, unitb, material = "") => {
  unita = unita?.toLowerCase?.() ?? unita;
  unitb = unitb?.toLowerCase?.() ?? unitb;
  try {
    // Si las unidades de origen y destino son iguales, no hacer conversión
    if (!value) {
      return 0;
    }

    if (unita === unitb) {
      return value;
    }

    const esMoneda = (unidad) =>
      coins_units.some((moneda) => moneda.value === unidad);

    // Si estamos trabajando con monedas, retornar el mismo valor (sin conversión por ahora)
    if (esMoneda(unita) && esMoneda(unitb)) {
      return value;
    }

    // ✅ Primero intentar con nuestra función personalizada simple (más confiable)
    // Soporta: g, kg, t, ton (masa) y l, m3 (volumen)
    const unidadesSoportadas = ["g", "kg", "t", "ton", "l", "m3"];
    if (unidadesSoportadas.includes(unita) && unidadesSoportadas.includes(unitb)) {
      return convertUnitsFinalSimple(value, unita, unitb);
    }

    // Si no están en nuestras unidades soportadas, intentar con convert-units
    try {
      const result = convert(value).from(unita).to(unitb);
      if (!isNaN(result)) {
        return result;
      }
    } catch (err) {
      // Si convert-units falla, continuar con el fallback
    }

    // Si convert-units no funciona, usar función personalizada como fallback
    let densidad = densidades[material]?.density || 1;
    let unitDensity = densidades[material]?.unit_density || "g/cm3";
    return convertUnitsFinalSimple(value, unita, unitb, densidad, unitDensity);

  } catch (error) {
    console.error(`Error de conversión de ${unita} a ${unitb}:`, error.message);
    return null;
  }
};

export const convertUnitsFinalSimple = (value, unitFrom, unitTo) => {
  unitFrom = unitFrom?.toLowerCase?.() ?? unitFrom;
  unitTo = unitTo?.toLowerCase?.() ?? unitTo;
  if (value == null || isNaN(value)) return 0;

  const masa = { g: 1, kg: 1000, t: 1000000, ton: 1000000 };
  const volumen = { l: 1, m3: 1000 }; // 1 m3 = 1000 litros

  const esMasa = (u) => Object.keys(masa).includes(u);
  const esVolumen = (u) => Object.keys(volumen).includes(u);

  // Misma unidad, no convertir (incluyendo aliases como "ton" === "t")
  if (unitFrom === unitTo) return value;
  if ((unitFrom === "ton" && unitTo === "t") || (unitFrom === "t" && unitTo === "ton")) return value;

  // Masa a masa
  if (esMasa(unitFrom) && esMasa(unitTo)) {
    const valueInGrams = value * masa[unitFrom];
    return valueInGrams / masa[unitTo];
  }

  // Volumen a volumen
  if (esVolumen(unitFrom) && esVolumen(unitTo)) {
    const valueInLiters = value * volumen[unitFrom];
    return valueInLiters / volumen[unitTo];
  }

  // Si no se puede convertir, retornar el valor original en lugar de NaN
  console.warn(
    `⚠️ Conversión no soportada de ${unitFrom} a ${unitTo}, retornando valor original`
  );
  return value;
};
